import React, { useState, useEffect } from "react";
import "./companies.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getStaticUrl } from "../../../../utils/getStaticUrl";
import { getJsonFromStorage } from "../../../../utils/getJsonFromStorage";
import Spinner from "react-bootstrap/Spinner"; // Import Bootstrap Spinner

function Companies() {
  const [otherLogos, setOtherLogos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchCompanies = async () => {
      const jsonData = await getJsonFromStorage("companies.json");
      if (jsonData && jsonData.partners && jsonData.others) {
        setOtherLogos(jsonData.others.map(getStaticUrl));
      } else {
        setError(true);
      }
      setLoading(false);
    };

    fetchCompanies();
  }, []);

  const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 520, settings: { slidesToShow: 3 } },
    ],
  };

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner animation="border" role="status"></Spinner>
      </div>
    );
  if (error) return <p>Error cargando compañias.</p>;

  return (
    <>
      <div className="companies-boxes">
        <div className="companies-text-box">
          <p className="companies-title">
            Muchas empresas y organizaciones ya se han sumado a nuestro
            propósito
          </p>
          <div className="companies-image-text">
            <div className="companies-image">
              <img src={getStaticUrl("icons/porotito.png")} alt="companies" />
              <img
                src={getStaticUrl("icons/mano-herramienta.png")}
                alt="companies"
              />
            </div>
            <p>
              RedMaestra es la solución concreta para transformar tu compromiso
              social en un impacto real y positivo.
            </p>
          </div>
          <button onClick={() => setShowModal(true)} className="yellowbut">
            ¡Únete aquí!
          </button>
        </div>
        <div className="companies-image-box">
          <div className="companies-image-logos">
            <img
              src={getStaticUrl("c_logos/logo-lipigas.png")}
              alt="companies"
            />
            <img
              src={getStaticUrl("c_logos/logo-polpaico.png")}
              alt="companies"
            />
            <img
              src={getStaticUrl("c_logos/logo-sodimac.png")}
              alt="companies"
            />
            <img src={getStaticUrl("c_logos/logo-wcb.png")} alt="companies" />
          </div>
          <div className="container">
            <Slider {...settings}>
              {otherLogos.map((logo, index) => (
                <div className="slide" key={index}>
                  <img src={logo} alt={`Other Logo ${index}`} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h6 style={{ textAlign: "left" }}>
              Redireccionando al formulario específico
              <br /> 😉👍
            </h6>
            <div className="modal-buttons companies-modal-buttons">
              <a
                href="https://redmaestra.azurewebsites.net/api/formularios/agregar_empresas/"
                className="btn btn-outline-danger"
              >
                Empresa
              </a>
              <a
                href="https://redmaestra.azurewebsites.net/api/formularios/agregar_comunidades/"
                className="btn btn-outline-success"
              >
                Persona
              </a>
            </div>
            <button
              className="btn btn-secondary close-btn"
              onClick={() => setShowModal(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Companies;
